import { BreakdownTypes } from '@wix/cashier-express-checkout-widget/dist/src/types/PaymentBreakdown';
import { round } from './math.utils';
export function getPaymentBreakdown(_ref, taxOnProduct) {
  var _shippingInfo$selecte, _payNow$shipping, _payNow$tax, _payNow$discount, _giftCard$amount;
  let {
    payNow,
    giftCard,
    lineItems,
    additionalFees,
    shippingInfo
  } = _ref;
  const itemsTotal = getItemsTotal(lineItems);
  const shippingTotal = taxOnProduct ? (shippingInfo == null || (_shippingInfo$selecte = shippingInfo.selectedCarrierServiceOption) == null || (_shippingInfo$selecte = _shippingInfo$selecte.cost) == null || (_shippingInfo$selecte = _shippingInfo$selecte.price) == null ? void 0 : _shippingInfo$selecte.amount) ?? '0' : (payNow == null || (_payNow$shipping = payNow.shipping) == null ? void 0 : _payNow$shipping.amount) ?? '0';
  const taxTotal = taxOnProduct ? '0' : (payNow == null || (_payNow$tax = payNow.tax) == null ? void 0 : _payNow$tax.amount) ?? '0';
  const discountTotal = (payNow == null || (_payNow$discount = payNow.discount) == null ? void 0 : _payNow$discount.amount) ?? '0';
  const giftCardTotal = (giftCard == null || (_giftCard$amount = giftCard.amount) == null ? void 0 : _giftCard$amount.amount) ?? '0';
  const additionalFeesTotal = getItemsTotal(additionalFees);
  const itemsTotalWithAdditionalFees = round(Number(itemsTotal) + Number(additionalFeesTotal)).toString();
  const totalDiscountWithGiftCard = round(Number(discountTotal) + Number(giftCardTotal)).toString();
  return {
    [BreakdownTypes.ItemsTotal]: itemsTotalWithAdditionalFees,
    [BreakdownTypes.Shipping]: shippingTotal,
    [BreakdownTypes.Tax]: taxTotal,
    [BreakdownTypes.Discount]: totalDiscountWithGiftCard
  };
}
function getItemsTotal(items) {
  const total = (items ?? []).reduce((acc, _ref2) => {
    let {
      price,
      quantity
    } = _ref2;
    return acc + Number((price == null ? void 0 : price.amount) ?? '0') * (quantity ?? 1);
  }, 0);
  return round(total).toString();
}
//# sourceMappingURL=getPaymentBreakdown.js.map